module.exports = __webpack_public_path__ + "static/media/data_2.c4fe1dcb.svg";